var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShirts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5041 0.519286C14.6306 0.205655 14.937 0 15.2778 0H29.7222C30.0149 0 30.2861 0.152247 30.4368 0.401069L31.8607 2.75362H35.2777C35.4339 2.75362 35.5869 2.79713 35.7194 2.87919L44.6082 8.38644C44.9641 8.60693 45.0991 9.05539 44.9232 9.43314L41.5899 16.5926C41.4954 16.7955 41.3219 16.9519 41.1091 17.0259C40.8963 17.0999 40.6623 17.0852 40.4606 16.9853L36.111 14.8294V37.1739C36.111 37.6301 35.7379 38 35.2777 38H9.16671C8.70647 38 8.33338 37.6301 8.33338 37.1739V14.8294L3.98385 16.9853C3.77368 17.0894 3.52892 17.1008 3.30984 17.0166C3.09077 16.9323 2.91774 16.7603 2.83339 16.5429L0.0556266 9.3835C-0.0843416 9.02275 0.0467413 8.61401 0.371163 8.39961L8.70446 2.89236C8.84135 2.8019 9.00219 2.75362 9.16671 2.75362H13.6025L14.5041 0.519286ZM13.8215 4.4058H9.41902L4.10807 7.91566L6.789 13.7477L8.79403 12.7539C9.05235 12.6258 9.35914 12.6395 9.60482 12.79C9.8505 12.9406 10 13.2064 10 13.4928V36.3478H34.4444V13.4928C34.4444 13.2064 34.5939 12.9406 34.8396 12.79C35.0853 12.6395 35.3921 12.6258 35.6504 12.7539L38.1871 14.0112L40.7536 7.94657L35.0387 4.4058H31.734L26.4226 9.67109C26.2517 9.84042 26.0152 9.92794 25.7742 9.91097C25.6129 9.8996 25.4601 9.84211 25.3333 9.74783V16.2464C25.3333 16.7026 24.9602 17.0725 24.5 17.0725H20.8333C20.3731 17.0725 20 16.7026 20 16.2464V9.86581C19.9412 9.88642 19.8797 9.90061 19.8165 9.90774C19.5642 9.93622 19.3125 9.8491 19.133 9.67109L13.8215 4.4058ZM21.6667 7.56156V15.4203H23.6666V7.6L22.5625 6.14063L21.6667 7.56156ZM23.7476 4.95342L29.4169 1.92729L30.3395 3.45165L25.9235 7.82931L23.7476 4.95342ZM26.4169 1.65217H18.5831L22.5 3.74293L26.4169 1.65217ZM15.7048 1.99223L15.1445 3.38075L19.5708 7.76854L21.3221 4.99068L15.7048 1.99223ZM42.1855 8.83375L39.6811 14.7517L40.4369 15.1263L43.1022 9.40169L42.1855 8.83375ZM5.29732 14.487L2.70329 8.84404L1.85063 9.40754L4.05947 15.1006L5.29732 14.487Z",
    fill: "url(#paint0_linear_3687_706)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3687_706",
    x1: 5.8131e-7,
    y1: 42.0714,
    x2: 49.2608,
    y2: 29.1533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirts);
export default __webpack_public_path__ + "static/media/shirts.7174e2cfed05408308040dfd9fc02d72.svg";
export { ForwardRef as ReactComponent };